import React from "react";
import styles from "./Blogs.module.scss";
import blogImg from "../../../assets/new-images/testimonial-image.png";
import blogImgTwo from "../../../assets/new-images/blog-2.jpg";
import blogImgThree from "../../../assets/new-images/blog-3.jpg";

const BlogCard = () => {
  const blogsCardData = [
    {
      img_span: "Adventure & Activities",
      img_title: "Lorem ipsum dolor sit amet consectetur Nisl rutrum leo",
      img_date: "26 March 2025",
      image: blogImg,
      description:
        "  Lorem ipsum. Ac commodo lacus ut elit  scelerisque elementum arcu. auctor  Ac commodo celerisque elementum arcu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium. Lorem ipsum. Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisqu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium ",
    },
    {
      img_span: "Adventure & Activities",
      img_title: "Lorem ipsum dolor sit amet consectetur Nisl rutrum leo",
      img_date: "26 March 2025",
      image: blogImgTwo,
      description:
        "  Lorem ipsum. Ac commodo lacus ut elit  scelerisque elementum arcu. auctor  Ac commodo celerisque elementum arcu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium. Lorem ipsum. Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisqu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium ",
    },
    {
      img_span: "Adventure & Activities",
      img_title: "Lorem ipsum dolor sit amet consectetur Nisl rutrum leo",
      img_date: "26 March 2025",
      image: blogImgThree,
      description:
        "  Lorem ipsum. Ac commodo lacus ut elit  scelerisque elementum arcu. auctor  Ac commodo celerisque elementum arcu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium. Lorem ipsum. Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisqu. Urna ut nulla pretium risus auctor  Ac commodo lacus ut elit  scelerisque elementum arcu. Urna ut nulla pretium ",
    },

  ];
  return (
    <div className={styles.blogs_flex}>
      {" "}
      {blogsCardData?.map((item, i) => (
        <div class={styles.flip_box} key={i}>
          <div class={styles.flip_box_inner}>
            <div class={styles.flip_box_front}>
              {" "}
              <div className={styles.inner_img_div}>
                <img src={item.image} alt="blog-image" />{" "}
                <div className={styles.img_content}>
                  <span>{item.img_span}</span>
                  <h4>{item.img_title} </h4>
                  <small>{item.img_date}</small>
                  <div className="flex justify_content_center">
                    <div className={styles.next_icon}>
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_6868_17700"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="16"
                          height="17"
                        >
                          <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_6868_17700)">
                          <path
                            d="M5.33595 14.705L4.62695 13.996L10.1231 8.49984L4.62695 3.00368L5.33595 2.29468L11.5411 8.49984L5.33595 14.705Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class={styles.flip_box_back}>
              <div>
                {" "}
                <span>{item.img_span}</span>
                <h4>{item.title}</h4>
                <small>{item.img_date}</small>
                <p>{item?.description}</p>
            
                <div className="flex justify_content_center">
                    <div className={styles.next_icon}>
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_6868_17700"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="16"
                          height="17"
                        >
                          <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_6868_17700)">
                          <path
                            d="M5.33595 14.705L4.62695 13.996L10.1231 8.49984L4.62695 3.00368L5.33595 2.29468L11.5411 8.49984L5.33595 14.705Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogCard;
